export class DocumentoDTO {
	codiceTipoEmittente: string;
	dataDocumento: Date;
	nomeDocumento: string;
	nota: string;
	numeroDocumento: string;
	soggettoEmittente: string;
	tipoDocumento: string;
}